import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Col } from '@sm/wds-react';

export const SurveyTypesColumn = ({ children, title }) => {
  return (
    <Col className="sm-nav-submenu__col">
      <Typography
        variant="cardTitle"
        color="dark"
        className="sm-nav-submenu__column-title"
      >
        {title}
      </Typography>
      {children}
    </Col>
  );
};

export default SurveyTypesColumn;

SurveyTypesColumn.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};
